import { useLanguage } from "assets/languages";

function getFormErrorMessage(formStateErrors:any, formKey_name_map:{
  [formKey:string]: string,
}): string {
  const language = useLanguage();
  const languageText = {
    ...language.helper.reactHookForm,
  }

  const findFirstError = (obj: any): { path: string, type: string } | null => {
    if (!obj) {
      return null
    };
    
    for (const key in obj) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        if (obj[key].type) {
          return { path: key, type: obj[key].type };
        }
        const result = findFirstError(obj[key]);
        if (result) {
          return { path: `${key}.${result.path}`, type: result.type };
        }
      }
    }
    
    return null;
  };
  
  const error = findFirstError(formStateErrors);
  if (!error) {
    return ''
  };

  const errorMessages: Record<string, (fieldName: string) => string> = {
    'required': (fieldName) => languageText._error_required(fieldName),
    'pattern': (fieldName) => languageText._error_pattern(fieldName),
    'validate': (fieldName) => languageText._error_validate(fieldName),
  };
  
  const fieldName = formKey_name_map[error.path] || error.path;
  const getMessage = errorMessages[error.type] || (() => languageText.error_undefined);
  
  return getMessage(fieldName);
}

const HELPER_REACT_HOOK_FORM = {
  getFormErrorMessage,
}

export default HELPER_REACT_HOOK_FORM